// Central registry of product-tour targets.
//
// Each value is the stable `data-tour` attribute used to locate an element for
// the @reactour tour. Targeting by a dedicated data attribute (instead of the
// old `.step-N` style classNames) keeps the tour decoupled from styling: a
// visual refactor can rename or move classNames without silently breaking the
// tour, and every target is greppable and type-checked from this one file.
//
// To register an element as a target, spread `tourTarget(...)` onto it:
//   <div {...tourTarget(TOUR_TARGET.stage)} />
// and reference it in lib/steps.ts via `tourSelector(...)`.
export const TOUR_TARGET = {
  /** The live GameLift stream surface (the "stage" you look around in). */
  stage: "stage",
  mic: "mic",
  camera: "camera",
  settingsButton: "settings-button",
  settingsPanel: "settings-panel",
  chatButton: "chat-button",
  chatPanel: "chat-panel",
  videoBackground: "video-background",
  help: "help",
  talkingHead: "talking-head",
  resources: "resources",
  sponsors: "sponsors",
} as const;

export type TourTargetId = (typeof TOUR_TARGET)[keyof typeof TOUR_TARGET];

/** CSS selector reactour needs, derived from a semantic target id. */
export const tourSelector = (id: TourTargetId): string => `[data-tour="${id}"]`;

/** Spread onto any element to register it as a tour target. */
export const tourTarget = (
  id: TourTargetId,
): { "data-tour": TourTargetId } => ({ "data-tour": id });
